import React, { createContext, useContext } from "react"
import { useTranslation } from "react-i18next"

import { isMac } from "shared/lib/browser/detectBrowser"

export const TabBarTabFocusContext = createContext(false)

interface TabBarTabTooltipContentProps {
  text: string
}

export function TabBarTabTooltipContent({
  text
}: TabBarTabTooltipContentProps) {
  const { t } = useTranslation()
  const isFocused = useContext(TabBarTabFocusContext)
  const shortcut = isMac ? "⌥↓" : "Alt+↓"
  const shortcutHint = t("TabBar.KeyboardHint", { shortcut })

  return (
    <div className="tab-bar__tooltip-content">
      <div className="tab-bar__tooltip-text">{text}</div>
      {isFocused && (
        <div className="tab-bar__tooltip-shortcut-hint">{shortcutHint}</div>
      )}
    </div>
  )
}
